<div class="container-fluid px-0 bg-star">
    <div class="container py-5">
        <div class="row">
            <div class="col-md-12 col-lg-10 m-auto">
                <div class="text-center">
                    <h3>Our Pricing</h3>
                    <p class="section-sub-heading">Learn new skills, drills and technique that you can apply immediately in
                        practice.<br/>
                        Find countless options that will work for your athletes and new and creative choreography ideas,
                        each with coach notes,
                        legality tips and more.
                    </p>
                    <p _ngcontent-pax-c139="" class="section-sub-heading">  
 
                        <b style="  font-size: 20px;  "> Level 1 – <span class="badge rounded-pill text-light  bg-danger p-2" style="
                            background: var(--first-color); ">  
                            <i class="fa-solid fa-crown"></i> FREE!</span></b> 
                            <br>
                        All the same features of Coach &amp; Gym Owner L1-3. Fall in love with The Cheer Forge, no strings attached! 
                    </p>
                    <a routerLink="/signup" class="card__button mb-3 d-inline-block">Sign Up</a>
                </div>
                <div *ngIf="plans && dynamicPlans" class="pills-wrap">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="pills-level13-tab" data-bs-toggle="pill" data-bs-target="#pills-level13" type="button" role="tab" aria-controls="pills-level13" aria-selected="true">Level 1-3</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pills-level14-tab" data-bs-toggle="pill" data-bs-target="#pills-level14" type="button" role="tab" aria-controls="pills-level14" aria-selected="false">Level 1-4</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="pills-alllevel-tab" data-bs-toggle="pill" data-bs-target="#pills-alllevel" type="button" role="tab" aria-controls="pills-alllevel" aria-selected="false">All Levels</button>
                        </li>
                    </ul>
                </div>
                <div *ngIf="plans && dynamicPlans" class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-level13" role="tabpanel" aria-labelledby="pills-level13-tab">
                        <section class="grid">
                            <div class="card__container grid">
                                <ng-container *ngIf="plans">
                                    <ng-container *ngFor="let plan of plans | keyvalue">
                                        <ng-container *ngFor="let plandetail of plan.value">
                                            <article *ngIf="plandetail.level=='Level 1-3' && getPlanPrice(plan.key,plandetail.codes,plandetail.type)" class="card__content grid">
                                                <div class="card__pricing"> 
                                                    <div class="card__pricing-number">
                                                        <span class="card__pricing-symbol">$</span>{{getPlanPrice(plan.key,plandetail.codes,plandetail.type)}}
                                                    </div>
                                                    <span class="card__pricing-month">{{plandetail.type}}</span>
                                                </div>
                    
                                                <header class="card__header">
                    
                                                    <span class="card__header-subtitle">{{plandetail.level}}</span>
                                                    <h1 class="card__header-title text-uppercase">{{plan.key}}</h1>
                                                </header>
                    
                                                <div class="toggle">
                                                    <label>Monthly</label>
                                                    <div class="toggle-btn">
                                                        <input type="checkbox" class="checkbox" id="checkbox{{plan.key+''+plandetail.id}}" (click)="changeValue(plandetail,plandetail.type)" />
                                                        <label class="sub" id="sub" for="checkbox{{plan.key+''+plandetail.id}}">
                                                            <div class="circle"></div>
                                                        </label>
                                                    </div>
                                                    <label>Annually</label>
                                                </div>
                    
                                                <div class="included-text">What's Included</div>
                    
                                                <ul class="card__list grid">
                                                    <li class="card__list-item" *ngFor="let features of plandetail.details">
                                                        <i class="uil uil-check fa-solid {{features.icon}}"></i>
                                                        <p class="card__list-description">{{features.description}}</p>
                                                    </li>
                                                </ul>
                    
                                                <a *ngIf="plan.key!='schoolcoach'" routerLink="/signup" class="card__button">Sign Up</a>
                                                <p *ngIf="plan.key=='schoolcoach'" class="text-red">*Contact us for this Membership</p>
                                            </article>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                
                            </div>
                        </section>
                    </div>
                    <div class="tab-pane fade" id="pills-level14" role="tabpanel" aria-labelledby="pills-level14-tab">
                        <section class="grid">
                            <div class="card__container grid">
                                <ng-container *ngIf="plans">
                                    <ng-container *ngFor="let plan of plans | keyvalue">
                                        <ng-container *ngFor="let plandetail of plan.value">
                                            <article *ngIf="plandetail.level=='Level 1-4' && getPlanPrice(plan.key,plandetail.codes,plandetail.type)" class="card__content grid">
                                                <div class="card__pricing">
                                                    <div class="card__pricing-number">
                                                        <span class="card__pricing-symbol">$</span>{{getPlanPrice(plan.key,plandetail.codes,plandetail.type)}}
                                                    </div>
                                                    <span class="card__pricing-month">{{plandetail.type}}</span>
                                                </div>
                    
                                                <header class="card__header">
                    
                                                    <span class="card__header-subtitle">{{plandetail.level}}</span>
                                                    <h1 class="card__header-title text-uppercase">{{plan.key}}</h1>
                                                </header>
                    
                                                <div class="toggle">
                                                    <label>Monthly</label>
                                                    <div class="toggle-btn">
                                                        <input type="checkbox" class="checkbox" id="checkbox{{plan.key+''+plandetail.id}}" (click)="changeValue(plandetail,plandetail.type)" />
                                                        <label class="sub" id="sub" for="checkbox{{plan.key+''+plandetail.id}}">
                                                            <div class="circle"></div>
                                                        </label>
                                                    </div>
                                                    <label>Annually</label>
                                                </div>
                    
                                                <div class="included-text">What's Included</div>
                    
                                                <ul class="card__list grid">
                                                    <li class="card__list-item" *ngFor="let features of plandetail.details">
                                                        <i class="uil uil-check fa-solid {{features.icon}}"></i>
                                                        <p class="card__list-description">{{features.description}}</p>
                                                    </li>
                                                </ul>
                    
                                                <a *ngIf="plan.key!='schoolcoach'" routerLink="/signup" class="card__button">Sign Up</a>
                                                <p *ngIf="plan.key=='schoolcoach'" class="text-red">*Contact us for this Membership</p>
                                            </article>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </section>
                    </div>
                    <div class="tab-pane fade" id="pills-alllevel" role="tabpanel" aria-labelledby="pills-alllevel-tab">
                        <section class="grid">
                            <div class="card__container grid">
                                <ng-container *ngIf="plans">
                                    <ng-container *ngFor="let plan of plans | keyvalue">
                                        <ng-container *ngFor="let plandetail of plan.value">
                                            <article *ngIf="plandetail.level=='All Levels' && getPlanPrice(plan.key,plandetail.codes,plandetail.type)" class="card__content grid">
                                                <div class="card__pricing">
                                                    <div class="card__pricing-number">
                                                        <span class="card__pricing-symbol">$</span>{{getPlanPrice(plan.key,plandetail.codes,plandetail.type)}}
                                                    </div>
                                                    <span class="card__pricing-month">{{plandetail.type}}</span>
                                                </div>
                    
                                                <header class="card__header">
                                                    <span class="card__header-subtitle">{{plandetail.level}}</span>
                                                    <h1 class="card__header-title text-uppercase">{{plan.key}}</h1>
                                                </header>
                    
                                                <div class="toggle">
                                                    <label>Monthly</label>
                                                    <div class="toggle-btn">
                                                        <input type="checkbox" class="checkbox" id="checkbox{{plan.key+''+plandetail.id}}" (click)="changeValue(plandetail,plandetail.type)" />
                                                        <label class="sub" id="sub" for="checkbox{{plan.key+''+plandetail.id}}">
                                                            <div class="circle"></div>
                                                        </label>
                                                    </div>
                                                    <label>Annually</label>
                                                </div>
                    
                                                <div class="included-text">What's Included</div>
                    
                                                <ul class="card__list grid">
                                                    <li class="card__list-item" *ngFor="let features of plandetail.details">
                                                        <i class="uil uil-check fa-solid {{features.icon}}"></i>
                                                        <p class="card__list-description">{{features.description}}</p>
                                                    </li>
                                                </ul>
                                                <a *ngIf="plan.key!='schoolcoach'" routerLink="/signup" class="card__button">Sign Up</a>
                                                <p *ngIf="plan.key=='schoolcoach'" class="text-red">*Contact us for this Membership</p>
                                            </article>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </section>
                    </div>
                </div>
                  
            </div>
        </div>
    </div>
</div>